module.exports = __webpack_public_path__ + "img/welcome-page.b0a75649.svg";